var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.63745,
    height: 17.95955,
    viewBox: "0 0 10.63745 17.95955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.60833,9.16939c.01239-.06366.02917-.12463.02911-.18933.00006-.0647-.01672-.12567-.02911-.18933-.01208-.06219-.01904-.12323-.04315-.18286-.02502-.06232-.06683-.11536-.1048-.17242-.02924-.04407-.04449-.09399-.08154-.13409-.0094-.01019-.02264-.01367-.03235-.02338s-.01312-.02289-.02332-.03229L1.67865.26521C1.2724-.10979.63861-.08342.26556.32088c-.375.40625-.34961,1.03906.05566,1.41309l7.849,7.24603L.32122,16.22517c-.40527.37402-.43066,1.00684-.05566,1.41309.19629.21289.46484.32129.73438.32129.24316,0,.48633-.08789.67871-.26562l8.64453-7.97949c.0105-.0097.0141-.02332.02411-.03333.00946-.00946.02246-.01245.03156-.02234.03705-.0401.05231-.09003.08154-.13409.03796-.05707.07977-.11011.1048-.17242.02411-.05963.03107-.12067.04315-.18286Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSingle);
export default __webpack_public_path__ + "static/media/arrow-single.29782b3476364935a4dc3385a6aaa4d9.svg";
export { ForwardRef as ReactComponent };